<template>
  <article class="flex flex-col">
    <h1 class="mb-[24px] font-roboto text-[32px] font-medium leading-6">
      Аудиолекции
    </h1>
    <CommonComplexFiltering
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="audioRubrics?.data?.value"
      is-centuries-disabled
      :filters-active="filters"
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="lecture in audioLectures?.data?.value?.data"
        :key="lecture.id"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="lecture"
        is-small-title
        :title-length="60"
      >
        <template #cover>
          <AudioStandAlonePlayButton
            v-if="lecture?.path"
            :data="lecture"
            class="absolute left-1/2 top-1/2 z-40 hidden -translate-x-1/2 translate-y-1/2 md:flex"
            @on-play="setList()"
          >
          </AudioStandAlonePlayButton>
        </template>
      </MainPageCardsReworkedBaseCard>
    </div>
    <BaseThePagination
      v-show="isDev"
      :paginate-pages="paginatePages"
      :total-pages="totalPages"
      :page="page"
      :view-page="viewPage"
      :offset="OFFSET"
    />

    <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="audioLectures.hasNextPage.value"
        text="Показать еще"
        @click="audioLectures.fetchNextPage()"
      />
    </div>
  </article>
</template>

<script setup>
const OFFSET = 3;

const route = useRoute();

const audioStore = useAudioStore();

const filters = computed(() => {
  return {
    category: route.query?.category,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
const viewPage = ref(page.value);
const { audioLectures, resetPage } = useAudioLectures({
  filters,
  per_page: 9,
  page,
});
const totalPages = computed(
  () => audioLectures?.data?.value?.meta?.last_page ?? 0,
);
const { audioRubrics } = useAudioCategories();

const isDev = computed(() => {
  if (process.client) {
    return localStorage.getItem('isDev') === 'true';
  }
  return false;
});

const paginatePages = computed(() => {
  const arr = [];
  for (
    let i = Math.max(page.value - OFFSET, 1);
    i <= Math.min(page.value + OFFSET, totalPages.value);
    i++
  ) {
    arr.push(i);
  }
  return arr;
});

watch(
  () => audioLectures?.data?.value?.meta?.current_page,
  (value) => {
    if (!value) return;
    viewPage.value = value;
  },
);

watch(filters, (_, prevValue) => resetPage(prevValue));
const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const setList = () => {
  audioStore.setCurrentCategoryList('lectures');
  audioStore.setCurrentAudioList(audioLectures?.data?.value);
};

useHead({
  title:
    'Аудиолекции по истории РФ для школьников и студентов | Слушать на Федеральном портале Истории России',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Аудиолекции истории России от выдающихся профессоров и историков нашей страны.*Название*. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      hid: 'keywords',
      name: 'keywords',
      content: 'Аудиолекции по истории РФ для школьников и студентов',
    },
  ],
});
</script>

<style lang="scss"></style>
